import React from 'react';
import { W7C_ECOSYSTEM_PRESENTATIONS_URL, STUDIO_CREDITS_URL } from '../../utils/externalLinks';

/** Navigation to the teams' public surfaces; their catalogs remain with their owners. */
const DIRECTIONS = [
  {
    name: 'Romapa',
    role: 'Проектирование и моделирование',
    description: 'Планировки, модели объектов, чертежи и подготовка к изготовлению. От исходной идеи до согласованного состава проекта.',
    destination: 'Обсудить проект',
    href: 'https://pro.romapa.ru/',
    owner: 'Направление ООО «Маркбэйс»',
  },
  {
    name: 'VDE76',
    role: 'Товары и работы на объекте',
    description: 'Подбор материалов, проектные задачи и монтаж. Состав работ и комплектацию обсуждаем с учётом вашего объекта.',
    destination: 'Перейти в VDE76',
    href: 'https://vde76.ru/',
    owner: 'Магазин и услуги ИП',
  },
  {
    name: 'ВЭЙСЭН',
    role: 'Разработка и автоматизация',
    description: 'Сайты, магазины, рабочие кабинеты и цифровые инструменты для команды. Услуги и условия — в каталоге студии.',
    destination: 'Посмотреть услуги',
    href: `${STUDIO_CREDITS_URL}/uslugi`,
    owner: 'Направление ООО «Маркбэйс»',
  },
];

export default function LandingEcosystem() {
  return (
    <section id="ecosystem" className="landing-info-section lp-ecosystem" aria-labelledby="ecosystem-title">
      <div className="landing-info-section__inner">
        <div className="landing-info-section__label">Направления и проекты</div>
        <h2 id="ecosystem-title" className="landing-info-section__title">От идеи и модели — к работе на объекте</h2>
        <p className="landing-info-section__text">
          Markbase — цифровая платформа и команда, которая развивает собственные направления и помогает другим компаниям.
          Здесь можно выбрать услугу, найти товары для проекта или подключить инструменты для своего бизнеса.
        </p>
        <div className="lp-ecosystem__list">
          {DIRECTIONS.map((item) => (
            <a className="lp-ecosystem__item" key={item.name} href={item.href}>
              <span className="lp-ecosystem__identity">
                <strong>{item.name}</strong>
                <span>{item.owner}</span>
              </span>
              <div className="lp-ecosystem__description">
                <h3>{item.role}</h3>
                <span>{item.description}</span>
              </div>
              <span className="lp-ecosystem__destination">{item.destination} <span aria-hidden="true">↗</span></span>
            </a>
          ))}
        </div>
        <div className="lp-ecosystem__platform">
          <div>
            <h3>Markbase — основа для бизнеса</h3>
            <p>Каталоги, проекты, заказы и рабочие кабинеты. Платформу развивает ООО «Маркбэйс»; у каждой компании остаются свои услуги, данные и условия работы.</p>
          </div>
          <a className="btn-secondary" href="#modules">Возможности платформы <span aria-hidden="true">↓</span></a>
        </div>
        <a className="lp-ecosystem__more" href={W7C_ECOSYSTEM_PRESENTATIONS_URL}>Все презентации проектов <span aria-hidden="true">↗</span></a>
      </div>
    </section>
  );
}
